import styled, { CSSObject } from '@emotion/styled'
import { Button } from '../Controls'
import { IoCartOutline } from 'react-icons/io5'
import { StyledHTMLElement } from 'shop/theme/types'

interface Props {
  closeModal: (modalName: string) => void
  isModal: boolean
}

const EmptyCartState = ({ closeModal, isModal }: Props) => {
  return (
    <EmptyCartContainer isModal={isModal}>
      <CartIcon size='24px' />
      <EmptyCartText>Your Cart is empty</EmptyCartText>
      {isModal && <Button onClick={() => closeModal('cart')}>View Menu</Button>}
    </EmptyCartContainer>
  )
}

const EmptyCartText = styled.p(({ theme }) => ({
  color: '#8B8B8B',
  fontSize: theme.fontSizes[2],
  fontWeight: 500,
  margin: '0 0 60px'
}))

const EmptyCartContainer = styled.div<StyledHTMLElement & { isModal: boolean }>(
  ({ isModal }): CSSObject => ({
    margin: isModal ? '35% 15% 0' : '50% 15% 0',
    textAlign: 'center',
    maxWidth: '350px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    alignContent: 'center',
    flexDirection: 'column'
  })
)

const CartIcon = styled(IoCartOutline)(() => ({
  width: '52px',
  height: '52px',
  color: '#8B8B8B',
  '& path, & circle': {
    strokeWidth: '26px'
  }
}))

export default EmptyCartState
